import { render, staticRenderFns } from "./selectionInfo.vue?vue&type=template&id=975a04f2"
import script from "./selectionInfo.vue?vue&type=script&lang=js"
export * from "./selectionInfo.vue?vue&type=script&lang=js"
import style0 from "./selectionInfo.vue?vue&type=style&index=0&id=975a04f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports